import { AltNeu, Bodenform, ForstAdresse, Geologie, stfgString, SubstratZeile } from "src/app/data-model";

// Re-export generischer Teile aus Library für Abwärtskompatibilität
export {
	decodeHTML,
	equals, notequals, lessOrEqual, greaterOrEqual, liesBetween,
	stringIsEmpty, stringIsNotEmpty, stringContains, stringDoesNotContain,
	numberIsEmpty, numberIsNotEmpty,
	dateEquals, dateNotequals, dateLessOrEqual, dateGreaterOrEqual, dateLiesBetween,
	anyOf,
	Operators,
	bounds_checkout_filter, design_filter,
	Condition, ICondition, ConditionExpression, ExpressionType, IConditionExpression
} from '@luzula/luzula-lib';

import { anyOf, Condition } from '@luzula/luzula-lib';

// Domänen-spezifische Konverter
export const forstadresseToString = function(a: ForstAdresse) { return `${a.abteilung}${a.unterabteilung}${a.teilflaeche}`; };
export const geologieToString = function(g: Geologie) { let s = ''; if (g.oben) s += `${g.oben}`; if (g.trenner) s += `${g.trenner}`; if(g.unten) s+=`${g.unten}`; return s; };
export const stringToNumber = function(s: string) { return parseInt(s); };
export const altNeuConverter = function(an: AltNeu<string|number>|undefined) { return !(an?.neu == null) ? an.neu : an?.alt; };

export const hbfToString = function(b: Bodenform) {
	let result = '';
	if (!b || !b.bf) return result;
	for (let i = 0; i < b.bf.length; ++i) {
		const bf = b.bf[i];
		if (i > 0) result += ' ' + bf.trenner + ' ' + bf.hbf;
		else result += bf.hbf;
	}
	if (b.suffix) result += (result.length > 0 ? ' ' : '') + b.suffix;
	return result;
}

export const fbfToString = function(b: Bodenform) {
	let result = '';
	if (!b || !b.bf) return result;
	for (let i = 0; i < b.bf.length; ++i) {
		const bf = b.bf[i];
		if (i > 0) result += ' ' + bf.trenner + ' ' + bf.fbf;
		else result += bf.fbf;
	}
	if (b.suffix) result += (result.length > 0 ? ' ' : '') + b.suffix;
	return result;
}

// Domänen-spezifische anyOf-Varianten
export const anyOfBaumarten = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) { if (typeof a === 'string') return func(cfunc?cfunc(a):a,...args); return anyOf(a, func, cfunc, ...args); };
export const anyOfVegetationen = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i < a.length; ++i) {
		const auf = a[i];
		if(!(auf==null)&&!(auf.vegetation==null)&&func(cfunc?cfunc(auf.vegetation):auf.vegetation,...args)) return true;
		if (!auf.vegetationen) continue;
		for (let j=0; j < auf.vegetationen.length; ++j) {
			const el = auf.vegetationen[j];
			if(!(el==null)&&!(el.vegetation==null)&&func(cfunc?cfunc(el.vegetation):el.vegetation,...args)) return true;
		}
	}
	return false;
};

export const anyOfHorizonte = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i < a.length; ++i) {
		const hor = a[i];
		if(hor == null || !hor.horizonte) continue;
		for (let j=0; j < hor.horizonte.length; ++j) {
			const h=hor.horizonte[j];
			if(!(h==null)&&func(cfunc?cfunc(h):h,...args)) return true;
		}
	}
	return false;
};

export const anyOfSubstrate = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i<a.length; ++i) {
		const s=a[i];
		if(!(s==null)&&func(cfunc?cfunc(s):s,...args)) return true;
	}
	return false;
};
export const substratToName = function(s: SubstratZeile) { return s!=null ? s.substrat : ''; };
export const substratToHumusgehalt = function(s: SubstratZeile) { return s!=null ? s.humusgehalt : ''; };
export const substratToLagerungsdichte = function(s: SubstratZeile) { return s!=null ? s.lagerungsdichte : ''; };
export const substratToFestigkeit = function(s: SubstratZeile) { return s!=null ? s.festigkeit : ''; };
export const substratToSkelettgehalt = function(s: SubstratZeile) { return s!=null ? s.skelettgehalt : ''; };
export const substratToKarbonatgehalt = function(s: SubstratZeile) { return s!=null ? s.karbonatgehalt : ''; };
export const substratToNWSK = function(s: SubstratZeile) { return s!=null ? s.nWsk : ''; };

export const anyOfProjects = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i < a.length; ++i) {
		const p = a[i];
		if(!(p==null)&&!(p.name==null)&&func(cfunc?cfunc(p.name):p.name,...args)) return true;
	}
	return false;
};
export const projectToName = function(p: any) { return p!=null ? p.name : ''; };

// Domänen-spezifische Feld-Definitionen (Bohrpunkte)
export const Values: any = {
	"Aufnahmedatum": { "type": "date", "accessor": "header.aufnahme.datum" },
	"Aufnahmetiefe": { "type": "number", "accessor": "header.aufnahme.tiefe" },
	"Baumart": { "type": "string", "accessor": "extendedHeader.baumarten", "array": true, "anyOf": anyOfBaumarten, "anyOfName": "anyOfBaumarten" },
	"Begründungsart": { "type": "string", "accessor": "extendedHeader.begruendungsart" },
	"Bestockungstyp": { "type": "string", "accessor": "extendedHeader.bestockungsTyp", "convert": altNeuConverter },
	"Entwässerungsverhalten": { "type": "string", "accessor": "extendedHeader.entwaesserungsverhalten" },
	"Feinbodenform": { "type": "string", "accessor": "header.bodenform", "convert": fbfToString },
	"Forstabteilung": { "type": "number", "accessor": "header.adresse.abteilung", "convert": stringToNumber },
	"Forstadresse": { "type": "string", "accessor": "header.adresse", "convert": forstadresseToString },
	"Forstamt": { "type": "string", "accessor": "header.forstamt" },
	"Forstbetrieb": { "type": "string", "accessor": "header.forstbetrieb" },
	"G-Horizont(G)": { "type": "number", "accessor": "extendedHeader.gHorizont.g" },
	"G-Horizont(Go)": { "type": "number", "accessor": "extendedHeader.gHorizont.go" },
	"G-Horizont(Gr)": { "type": "number", "accessor": "extendedHeader.gHorizont.gr" },
	"Geologie": { "type": "string", "accessor": "extendedHeader.geologie", "convert": geologieToString },
	"Grundwasserform": { "type": "string", "accessor": "header.wasserstufe" },
	"Hangneigung": { "type": "number", "accessor": "extendedHeader.hangneigung" },
	"Hangrichtung": { "type": "string", "accessor": "extendedHeader.hangrichtung" },
	"Hauptbodenform": { "type": "string", "accessor": "header.bodenform", "convert": hbfToString },
	"Horizonte": { "type": "string", "accessor": "Horizontfolge", "array": true, "anyOf": anyOfHorizonte, "anyOfName": "anyOfHorizonte" },
	"Humusauflage(Of)": { "type": "number", "accessor": "extendedHeader.humusAuflage.of" },
	"Humusauflage(Oh)": { "type": "number", "accessor": "extendedHeader.humusAuflage.oh" },
	"Humusauflage(Ol)": { "type": "number", "accessor": "extendedHeader.humusAuflage.ol" },
	"Humusform": { "type": "string", "accessor": "header.humusform.aufnahmeFlaeche", "convert": altNeuConverter },
	"Karbonat": { "type": "number", "accessor": "extendedHeader.karbonat" },
	"Kartierer": { "type": "string", "accessor": "header.aufnahme.kartierer" },
	"Klimabereich": { "type": "string", "accessor": "extendedHeader.klimabereich" },
	"Klimastufe": { "type": "string", "accessor": "extendedHeader.klimaStufe", "convert": altNeuConverter },
	"kMgCaP-Serie": { "type": "string", "accessor": "extendedHeader.kMgCaPSerie" },
	"Lage": { "type": "string", "accessor": "extendedHeader.lage" },
	"Meereshöhe": { "type": "number", "accessor": "extendedHeader.meereshoehe" },
	"Mesoklima": { "type": "string", "accessor": "extendedHeader.mesoklima" },
	"Mesorelief": { "type": "string", "accessor": "extendedHeader.mesorelief" },
	"Mischform": { "type": "string", "accessor": "extendedHeader.mischform" },
	"Moormächtigkeit": { "type": "number", "accessor": "header.moorMaechtigkeit" },
	"Morphologie": { "type": "string", "accessor": "extendedHeader.morphologie", "array": true },
	"Nummer": { "type": "string", "accessor": "header.nummer" },
	"nWsk": { "type": "number", "accessor": "extendedHeader.nWsk" },
	"nWsk-Stufe": { "type": "number", "accessor": "extendedHeader.nWskStufe" },
	"pH-Wert 1": { "type": "number", "accessor": "extendedHeader.ph.wert1" },
	"pH-Wert 2": { "type": "number", "accessor": "extendedHeader.ph.wert2" },
	"Projekt": { "type": "string", "accessor": "header.projects", "array": true, "anyOf": anyOfProjects, "anyOfName": "anyOfProjects" },
	"Punkttyp": { "type": "string", "accessor": "type" },
	"Relief": { "type": "string", "accessor": "extendedHeader.relief.relief" },
	"Revier": { "type": "string", "accessor": "header.revier" },
	"S-Horizont(S)": { "type": "number", "accessor": "extendedHeader.sHorizont.s" },
	"S-Horizont(Sd)": { "type": "number", "accessor": "extendedHeader.sHorizont.sd" },
	"S-Horizont(Sw)": { "type": "number", "accessor": "extendedHeader.sHorizont.gsw" },
	"Saugsaum": { "type": "number", "accessor": "extendedHeader.spiegelTiefe" },
	"Spiegeltiefe": { "type": "number", "accessor": "extendedHeader.spiegelTiefe" },
	"Stauwasserform": { "type": "string", "accessor": "header.wasserstufe2" },
	"STFG": { "type": "string", "accessor": "", "convert": stfgString },
	"Substrat:Festigkeit": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToFestigkeit },
	"Substrat:Humusgehalt": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToHumusgehalt },
	"Substrat:Karbonatgehalt": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToKarbonatgehalt },
	"Substrat:Lagerungsdichte": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToLagerungsdichte },
	"Substrat:nWSK": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToNWSK },
	"Substrat:Skelettgehalt": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToSkelettgehalt },
	"Substratfeuchte": { "type": "string", "accessor": "header.substratFeuchte" },
	"Substratfolge": { "type": "string", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToName },
	"V-Wert": { "type": "string", "accessor": "extendedHeader.vWertSaugsaum" },
	"Vegetation": { "type": "string", "accessor": "bodenvegetation.aufnahme.vegetationen", "array": true, "anyOf": anyOfVegetationen, "anyOfName": "anyOfVegetationen" },
	"Vegetationsformengruppe": { "type": "string", "accessor": "header.vegetationsformengruppe" },
	"Waldfunktion": { "type": "string", "accessor": "extendedHeader.waldfunktion" },
	"Witterung": { "type": "string", "accessor": "extendedHeader.witterung" },
	"Wuchsbezirk": { "type": "string", "accessor": "extendedHeader.wuchsbezirk" },
};

// Condition mit domänen-spezifischen Values konfigurieren
Condition.configure(Values);
